module.exports = __webpack_public_path__ + "img/ivanhoe_cambridge.51152de1.webp";